import { Route, UrlMatchResult, UrlSegment, UrlSegmentGroup } from '@angular/router';
import { cities } from './pro-listing/pro-listing-city';

export function ProfessionalFilterMatcher(segments: UrlSegment[], segmentGroup: UrlSegmentGroup, route: Route): UrlMatchResult {
  return ProFilterMatcher(segments, 'style');
}

export function CityFilterMatcher(segments: UrlSegment[], segmentGroup: UrlSegmentGroup, route: Route): UrlMatchResult {
  // If we don't have any segments
  if (!segments[0]) {
    return null;
  }

  if (segments[0].path.match(/^[a-zA-Z0-9_-]*$/)) {
    const slug = segments[0].path;
    if (!cities[slug]) {
      return null;
    }
    if (segments[1] && segments[2] && segments[1].path === 'page') {
      return {
        consumed: segments,
        posParams: {
          ["citySlug"] : new UrlSegment(slug, {}),
          ["city"] : new UrlSegment(cities[slug].label, {}),
          ["cityGeo"] : new UrlSegment(cities[slug].geoloc, {}),
          page: new UrlSegment(segments[2].path, {}),
        }
      };
    }
    return { consumed: [segments[0]], posParams: {
      ["citySlug"]: new UrlSegment(slug, {}),
      ["city"] : new UrlSegment(cities[slug].label, {}),
      ["cityGeo"] : new UrlSegment(cities[slug].geoloc, {})
    }};
  }

  return null;
}

export function ServiceTypeMatcher(segments: UrlSegment[], segmentGroup: UrlSegmentGroup, route: Route): UrlMatchResult {
  return ProFilterMatcher(segments, 'serviceType');
}
export function ProFilterMatcher(segments: UrlSegment[], filter = 'style'): UrlMatchResult {
  // If we don't have any segments
  if (!segments[0]) {
    return null;
  }

  if (segments[0].path.match(filter === 'style' ? /^style-[a-zA-Z0-9_-]*$/ :  /^type-[a-zA-Z0-9_-]*$/)) {
    const slugArray = (segments[0].path.split('-'));
    slugArray.shift();
    const slug = slugArray.join('-');
    if (segments[1] && segments[2] && segments[1].path === 'page') {
      return {
        consumed: [segments[0]],
        posParams: {
          [filter + "Slug"] : new UrlSegment(slug, {}),
          page: new UrlSegment(segments[2].path, {}),
        }
      };
    }
    return { consumed: [segments[0]], posParams: { [filter + "Slug"]: new UrlSegment(slug, {})}};
  }

  return null;
}
